//||------------------------script------------------------||
//||                                                      ||
//||      js skript: /js-scripte/script_header_img.js     ||
//||                                                      ||
//||------------------------script------------------------||
// Discription:
/* 
Cycles through five images every 10 seconds.
Arrow keys allow manual navigation.
*/

// import track / arrows
const track = document.getElementById("track");
const left = document.getElementById("arrow_l");
const right = document.getElementById("arrow_r");

// import dots
let dots = document.querySelectorAll(".dot");

let bild_index = 0; // start with picture 1
let time_image_change = 10000; //change every 10 sec
let quImg = 5; //5 pictures

// slide picture
function slide() {
  bild_index = (bild_index + 1) % quImg;

  track.style.transform = `translateX(-${bild_index * 100}%)`;

  dots.forEach((dot, i) => {
    dot.classList.toggle("active", i === bild_index);
  });
}

// start
dots.forEach((dot, i) => {
  dot.classList.toggle("active", i === bild_index);
});
setInterval(slide, time_image_change);

//chek window size
window.addEventListener("resize", () => {
  if (window.innerWidth >= 950) quImg = 3;
  else quImg = 5;
});

//arrows right clicked
right.addEventListener("click", () => {
  slide();
});

//arrow left clicked
left.addEventListener("click", () => {
  bild_index = bild_index - 2;
  if (bild_index <= -2) {
    bild_index = 3;
  }
  slide();
});
